import React, { useEffect, useState } from 'react';
import icon from '../../../../assets/shareholdersIcon.png';
import CustomInput from '../../../../components/CustomInputs/CustomInput';
import Select, { MultiValue } from 'react-select';
import client from '../../../../api/client';
import { Label } from 'flowbite-react';
import showToast from '../../../../components/CustomToast/toastHelper';

interface CreateCustomRoleProps{
    refreshPage:()=>void,
    close:()=>void
}
const CreateCustomRole = ({refreshPage, close}:CreateCustomRoleProps) => {
    const [permissions, setPermissions] = useState<any[]>([]);
    const [selectedOptions, setSelectedOptions] = useState<MultiValue<{ label: string; value: string }>>([]);
    const [selected, setSelected]= useState<any[]>()
    const [inputs, setInputs] =useState({
        name:"",
        description:""
    })
    useEffect(() => {
        const fetchData = async () => {
            await fetchPermissions();
        };
        fetchData();
    }, []);

    const fetchPermissions = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/role/permissions');
            setPermissions(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    };

    const createNewRole =async() =>{
        let payload = {
            description:inputs.description,
            name:inputs.name,
            permissions:selected
        }

        try {
            const response = await client.post('/subsidiary/dashboard/role/create', payload);
            const message = response?.data?.message;
            showToast(message, 'success');
            close();
            refreshPage()
          } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
              sessionStorage.clear();
              window.location.href = '/';
            } else {
              const message = err?.response?.data?.message;
              console.error('error getting data', err);
              showToast(message, 'error');
            }
          }
    }

    const permissionOptions = permissions.map(permission => ({
        label: permission.name,
        value: permission.id,
    }));



    const handleChange = (selected: MultiValue<{ label: string; value: string }>) => {
        setSelectedOptions(selected);
        const selectedId = selectedOptions?.map((item: any) => {
            setSelected(item.value);
        })
    };

    return (
        <div>
            <div className=''>
                <img src={icon} alt="icon" />
                <p className='font-semibold py-2'>Create custom role</p>
                <p className='text-sm'>Kindly fill in the information needed</p>
            </div>
            <div>
                <div>
                    <CustomInput label='Role Name' name='roleName' value={inputs.name} onChange={(e)=>setInputs({...inputs,name:e.target.value})}/>
                </div>
                <div>
                    <CustomInput label='Description' name='description' value={inputs.description} onChange={(e)=>setInputs({...inputs,description:e.target.value})}/>
                </div>
                <div className='my-4'>
                    <Label htmlFor='permissions' value='Permissions' />
                    <Select
                        options={permissionOptions}
                        isMulti
                        onChange={handleChange}
                        value={selectedOptions}
                        className="rounded-lg"
                    />
                </div>
                <div className='flex gap-4'>
                    <button className='w-1/4 border px-6 py-3 rounded-lg text-md font-semibold' onClick={()=>close()}>Cancel</button>
                    <button className='w-3/4 border px-6 py-3 rounded-lg bg-custom-button-green text-md font-semibold hover:bg-green-900 hover:text-white' onClick={()=>createNewRole()}>Create Role</button>
                </div>
            </div>
        </div>
    );
};

export default CreateCustomRole;
